import { useEffect, useState } from "react"


const mediaQuery = () => {
  if (typeof window === "undefined" || typeof MediaQueryList === 'undefined') {
    return { matches: false, addEventListener: () => { } }
  }

  return window.matchMedia('(prefers-color-scheme: dark)')
}

export const useDark = () => {
  const [isDarkTheme, setDarkTheme] = useState(mediaQuery().matches)

  useEffect(() => {
    const mediaQueryResult = mediaQuery()
    mediaQueryResult.addEventListener("change", (event) => {
      // @ts-ignore
      setDarkTheme(event.matches)
    })
  }, [])

  return isDarkTheme
}
